// extracted by mini-css-extract-plugin
export default {"Title":"BillingDetails_Title__t-QCn","FormTitle":"BillingDetails_FormTitle__szCUS"};